import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Widget } from './Widget.jsx';
import './styles.css';

/**
 * The widget's entry point.
 *
 * Configuration arrives as query parameters, because the page is loaded inside
 * an iframe on a customer's own site. `org` selects the tenant; everything else
 * about that tenant — languages, whether voice is on, whether recording is
 * offered — comes from the server, not from this bundle.
 */
const params = new URLSearchParams(location.search);
const orgSlug = params.get('org') ?? undefined;
const apiBase = params.get('api') ?? import.meta.env.VITE_API_URL ?? location.origin;

const root = document.getElementById('root');
if (!root) throw new Error('Widget root element is missing');

createRoot(root).render(
  <StrictMode>
    <Widget baseUrl={apiBase} socketUrl={apiBase} orgSlug={orgSlug} />
  </StrictMode>,
);
